import { useCallback, useEffect, useState } from 'react'
import { promocionesApi } from '../api/promociones'

/**
 * ABM mínimo de promociones — solo toggle activo/pausado.
 *
 * Las REGLAS (qué subrubro, qué descuento, NxM) viven hardcoded en el código
 * del storefront. Acá el dueño solo prende/apaga cada promo sin necesidad de
 * tocar código. Si el storefront no encuentra el slug en este listado activo,
 * no aplica la regla (badge "6×5" desaparece, carrito no descuenta).
 */
export default function PromocionesPage() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [busy, setBusy] = useState(null) // slug en proceso de toggle
  const [err, setErr] = useState('')

  const cargar = useCallback(() => {
    setLoading(true)
    setErr('')
    promocionesApi.listar()
      .then(({ data }) => setRows(data))
      .catch(() => setErr('No se pudieron cargar las promociones.'))
      .finally(() => setLoading(false))
  }, [])
  useEffect(() => { cargar() }, [cargar])

  const toggle = async (row) => {
    setBusy(row.slug)
    setErr('')
    try {
      const { data } = await promocionesApi.toggle(row.slug)
      setRows((rs) => rs.map((r) => (r.slug === data.slug ? data : r)))
    } catch {
      setErr(`No se pudo cambiar el estado de ${row.slug}.`)
    } finally {
      setBusy(null)
    }
  }

  return (
    <div style={{ maxWidth: 880 }}>
      <div style={st.head}>
        <h2 style={st.title}>Promociones</h2>
      </div>
      <p style={st.sub}>
        Las reglas (qué incluye, qué descuento, fechas) viven en el código del
        storefront. Acá solo activás o pausás cada promo. Cuando una promo está
        pausada, deja de mostrarse en la web y el carrito no aplica el
        descuento.
      </p>

      {err && <p style={st.err}>{err}</p>}

      {loading ? (
        <p style={{ color: '#94a3b8' }}>Cargando…</p>
      ) : rows.length === 0 ? (
        <p style={st.empty}>
          Todavía no hay promociones cargadas. Se agregan vía seeder cuando se
          define una nueva regla en el storefront.
        </p>
      ) : (
        <table style={st.table}>
          <thead>
            <tr>
              <th style={{ ...st.th, textAlign: 'left' }}>Promoción</th>
              <th style={{ ...st.th, textAlign: 'left' }}>Slug</th>
              <th style={st.th}>Estado</th>
              <th style={st.th}></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.slug}>
                <td style={st.td}>{r.descripcion}</td>
                <td style={{ ...st.td, ...st.mono }}>{r.slug}</td>
                <td style={{ ...st.td, textAlign: 'center' }}>
                  <span style={r.active ? st.badgeOn : st.badgeOff}>
                    {r.active ? 'Activa' : 'Pausada'}
                  </span>
                </td>
                <td style={{ ...st.td, textAlign: 'right' }}>
                  <button
                    style={r.active ? st.btnPause : st.btnPlay}
                    onClick={() => toggle(r)}
                    disabled={busy === r.slug}
                  >
                    {busy === r.slug
                      ? '…'
                      : r.active
                        ? '⏸ Pausar'
                        : '▶ Activar'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

const st = {
  head: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 },
  title: { fontSize: 22, fontWeight: 600, color: '#0f172a', margin: 0 },
  sub: { color: '#64748b', fontSize: 13, lineHeight: 1.5, margin: '0 0 18px' },
  err: { background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: '8px 12px', borderRadius: 6, fontSize: 13, marginBottom: 12 },
  empty: { background: '#f8fafc', border: '1px solid #e2e8f0', color: '#475569', padding: 16, borderRadius: 6, fontSize: 14 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 6, overflow: 'hidden' },
  th: { background: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '10px 12px', fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', textAlign: 'center' },
  td: { borderBottom: '1px solid #f1f5f9', padding: '12px' },
  mono: { fontFamily: 'ui-monospace,Menlo,monospace', fontSize: 12, color: '#475569' },
  badgeOn: { display: 'inline-block', padding: '3px 8px', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', background: '#dcfce7', color: '#166534', borderRadius: 4 },
  badgeOff: { display: 'inline-block', padding: '3px 8px', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', background: '#fef3c7', color: '#92400e', borderRadius: 4 },
  btnPause: { background: '#fff', color: '#b45309', border: '1px solid #fcd34d', borderRadius: 6, padding: '6px 14px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  btnPlay: { background: '#16a34a', color: '#fff', border: '1px solid #15803d', borderRadius: 6, padding: '6px 14px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
}
